// extracted by mini-css-extract-plugin
module.exports = {"root":"Advantage_root__aWpJG","title":"Advantage_title__lBHFQ","subtitle":"Advantage_subtitle__DNobr","image":"Advantage_image__Yqltq"};